export default __webpack_public_path__ + "static/media/group-634@2x.931dccde.png";